module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0046.jpg?v=73a9be7e";